import React, { lazy, createElement } from 'react';
import './index.css';
import { createRoot } from 'react-dom/client';
import { App } from './App';
// PERFORMANCE: Inject critical resource hints synchronously BEFORE React mounts.
if (typeof document !== 'undefined') {
  const head = document.head;
  if (!document.querySelector('link[rel="preconnect"][href*="cdn.magicpatterns"]')) {
    const preconnect = document.createElement('link');
    preconnect.rel = 'preconnect';
    preconnect.href = 'https://cdn.magicpatterns.com';
    preconnect.crossOrigin = 'anonymous';
    head.appendChild(preconnect);
  }
  if (!document.querySelector('link[rel="dns-prefetch"][href*="cdn.magicpatterns"]')) {
    const dnsPrefetch = document.createElement('link');
    dnsPrefetch.rel = 'dns-prefetch';
    dnsPrefetch.href = 'https://cdn.magicpatterns.com';
    head.appendChild(dnsPrefetch);
  }
  // Preload the LCP hero image so the browser starts downloading before React renders
  const heroImg = 'https://cdn.magicpatterns.com/uploads/d7jAEFhiFwPbdHfeXw4Vue/Diseno_sin_titulo_(8).webp';
  if (!document.querySelector(`link[rel="preload"][href="${heroImg}"]`)) {
    const preload = document.createElement('link');
    preload.rel = 'preload';
    preload.as = 'image';
    preload.href = heroImg;
    preload.setAttribute('fetchpriority', 'high');
    head.appendChild(preload);
  }
}
// PERFORMANCE: Static import of createRoot
const rootEl = document.getElementById('root')!;
createRoot(rootEl).render(<App data-id="element-385" />);
// PERFORMANCE: After the page is interactive, prefetch lazy chunks in idle time
if (typeof window !== 'undefined') {
  const prefetchLazy = () => {
    import('./components/ModulosSection').catch(() => {});
    import('./components/InsideSystemSection').catch(() => {});
    import('./components/ToolsSection').catch(() => {});
    import('./components/BonusSection').catch(() => {});
    import('./components/IsForYouSection').catch(() => {});
    import('./components/PricingSection').catch(() => {});
    import('./components/UpsellSection').catch(() => {});
    import('./components/TestimonialsSection').catch(() => {});
    import('./components/GuaranteeSection').catch(() => {});
    import('./components/FAQSection').catch(() => {});
    import('./components/CostOfNotHavingItSection').catch(() => {});
    import('./components/FinalPricingSection').catch(() => {});
    import('./components/Footer').catch(() => {});
  };
  if ('requestIdleCallback' in window) {
    ;
    (window as any).requestIdleCallback(prefetchLazy, {
      timeout: 4000
    });
  } else {
    setTimeout(prefetchLazy, 2500);
  }
}